import _ from 'lodash';
import { Component, Input, ViewChild, ElementRef, SimpleChanges } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { QuotationService } from '../../../../services/index';
import { Util } from '../../../../utils/index'
declare var google:any;
declare var moment:any;

@Component({
  selector: 'tracking',
  templateUrl: 'tracking.html',
  styles: [`
    agm-map {
      height: 400px;
      width: 100%;
    }
  `]
})

export class TrackingComponent {
  @Input() quotRoutes;
  @Input() cnsltnReq;

  @ViewChild("gm")
  googleMp: ElementRef;

  markers: Array<any> = [];
  latlngBounds;
  scrollWheel:boolean = false;
  zIndex:number = 1;
  track;
  trackDtl: Array<any>;

  dateFomatter:Function = Util.dateFomatter;

  constructor(
    private mapsAPILoader: MapsAPILoader,
    private quotationService: QuotationService
  ) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.quotRoutes) {
      if(this.quotRoutes != null) {
        this.quotationService.getTracking(this.cnsltnReq.reqNo).subscribe(
          resp => {
            if(resp.result) {
              this.track = resp.data;
              this.getFitBound(this.quotRoutes);
            } else {
              this.getFitBound(this.quotRoutes);
            }
          }
        );
      }
    }
  }

  getFitBound(quotRoutes) {
    this.markers = [];

    if(this.cnsltnReq.orgTp == 1) {
      this.markers.push({
        lat: this.cnsltnReq.orgLatitude,
        lng: this.cnsltnReq.orgLongitude,
        zIndex: 1,
        location: {
          name: this.cnsltnReq.orgAdrs,
          locationTypeNm: 'DOOR',
        },
      });
    }

    if(this.cnsltnReq.desTp == 1) {
      this.markers.push({
        lat: this.cnsltnReq.desLatitude,
        lng: this.cnsltnReq.desLongitude,
        zIndex: 1,
        location: {
          name: this.cnsltnReq.desAdrs,
          locationTypeNm: 'DOOR',
        }
      });
    }

    if(this.track != null) {
      this.trackDtl = this.track.trackingDtlList;
      let polIndex = _.findIndex(this.trackDtl, function(o) { return (o.status == 'LOAD' || o.status == 'DEPART'); });
      let polDtls = [];
      let podIndex = _.findIndex(this.trackDtl, function(o) { return (o.status == 'ARRIVE' || o.status == 'DISCHARGE'); });
      let podDtls = [];
      for(let j=0; j < this.trackDtl.length; j++) {
        if((j < polIndex || j == polIndex) || (polIndex == -1 && polIndex == -1)) {
          polDtls.push(this.trackDtl[j]);
        }
        if((j > podIndex || j == podIndex) && podIndex != -1) {
          podDtls.push(this.trackDtl[j]);
        }
      }


      for(let i = 0; i<quotRoutes.length; i++) {
        if(!quotRoutes[i].location || !quotRoutes[i].location.latitude || !quotRoutes[i].location.longitude) continue;
        if(quotRoutes[i].typeNm == "POL") {
          let polEtd = this.dateFomatter(this.track.polEtd);
          this.markers.push({
            lat: quotRoutes[i].location.latitude,
            lng: quotRoutes[i].location.longitude,
            zIndex: 1,
            location: quotRoutes[i].location,
            etd: polEtd,
            eta: null,
            dtl: polDtls,
          });
        } else if(quotRoutes[i].typeNm == "POD"){
          let podEta =  this.dateFomatter(this.track.podEta);
          this.markers.push({
            lat: quotRoutes[i].location.latitude,
            lng: quotRoutes[i].location.longitude,
            zIndex: 1,
            location: quotRoutes[i].location,
            eta: podEta,
            etd: null,
            dtl: podDtls,
          });
        } else {
          this.markers.push({
            lat: quotRoutes[i].location.latitude,
            lng: quotRoutes[i].location.longitude,
            zIndex: 1,
            location: quotRoutes[i].location,
            dtl: null,
          });
        }
      }
    } else {
      for(let i = 0; i<quotRoutes.length; i++) {
        if(!quotRoutes[i].location || !quotRoutes[i].location.latitude || !quotRoutes[i].location.longitude) continue;
        this.markers.push({
          lat: quotRoutes[i].location.latitude,
          lng: quotRoutes[i].location.longitude,
          zIndex: 1,
          location: quotRoutes[i].location,
        });
      }
    }
    
    this.latlngBounds = new google.maps.LatLngBounds();
    this.markers.forEach((marker) => {
        this.latlngBounds.extend(new google.maps.LatLng(marker.lat, marker.lng))
    });
  }

  scrollChange(event) {
    if(this.scrollWheel == false) {
      this.scrollWheel = true;
    } else {
      this.scrollWheel = false;
    }
  }

  dateTime(time) {
    return moment(time, 'YYYYMMDDHHmm').format('YYYY/MM/DD HH:mm');
  }

  dateTime2(time) {
    return this.dateFomatter(time).substr(2);
  }
}

export class Marker {
  lat: number;
  lng: number;
  zIndex: number;
  location: Location;
}


export class Location {
  cntryNm: string;
  type: string;
  cntryCd: string;
  name: string;
  locationId: number;
  latitude: number;
  longitude: number;
}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/tracking.ts